import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

function PrivateRoute({ children, requireInstructor = false }) {
  const { user, loading, isInstructor } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (requireInstructor && !isInstructor) {
    return <Navigate to="/" />;
  }

  return children;
}

export default PrivateRoute;